const initialState = {
  isAuth: localStorage.getItem('user')? true:false,
  user:  localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')):null,
  preToken:  localStorage.getItem('preToken')
};
export default function authReducer  (state=initialState, action)  {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload));
      return {
        ...state,
        isAuth: true,
        user: action.payload,
        token: action.payload.token,
      };
    case 'PRE_LOGIN':
      localStorage.setItem('preToken', action.payload.preToken);
      return {
        ...state,
        preToken: action.payload.preToken,
      };
    case 'LOGOUT':
      localStorage.clear();
      return {
        ...state,
        isAuth: false,
        user: null,
        preToken: null,
      };
    default:
      return state;
  }
};
